const qiniuUrl = 'https://up-z2.qiniup.com/'
const imgToken = 'https://third.tuolele.cn/qtoken.php'
const fileToken = 'https://third.tuolele.cn/qtoken.php?bucket=late-care-file'
const imgSpace = 'https://late-care.tuolele.cn/'
const fileSpace = 'https://late-care-file.tuolele.cn/'

const qiniuUpload = {
  qiniuUrl,
  imgToken,
  fileToken,
  imgSpace,
  fileSpace
}

export default qiniuUpload
